<template>
  <div>
    <!--<description-sollicitation :show-photo="false"></description-sollicitation>-->
    <b-overlay :show="showOverlay" class="b-overlay-app" rounded="sm">

      <h2>Saisie du suivi de sollicitation :</h2>
      <p> {{ evenement.libelle }} , {{ action.libelle }}</p>
      <form id="myForm">

        <div class="form-group categorisation">

          <label for="sollicitation">Sollicitation: </label>
          <input id="sollicitation" class="form-control" name="sollicitation" readonly type="text"
                 v-bind:value="sollicitationID"><br>

          <label for="evenement">Evenement: </label>
          <input id="evenement" class="form-control" name="evenement" readonly type="text"
                 v-bind:value="evenementID"><br>

          <label for="action">Action: </label>
          <input id="action" class="form-control" name="action" readonly type="text" v-bind:value="actionID"><br>

        </div>

        <div class="form-group shadow-textarea">
          <h3>Détail</h3>
          <textarea id="details" class="form-control z-depth-1" name="details" placeholder="Détaillez le suivi..."
                    rows="3"></textarea>
        </div>

        <button class="btn btn-success" @click="createSuivi">Envoyer</button>

      </form>
    </b-overlay>
  </div>
</template>

<script>
import toast from "../../js/toast";

export default {
  name: "FormulairePostSuiviSollicitation",
  data() {
    return {
      evenementID: this.$store.getters['evenements/selectedEvenement'],
      actionID: this.$store.getters['actions/selectedAction'],
      sollicitationID: this.$store.getters['sollicitations/selectedSollicitation'],
      showOverlay: false
    }
  },
  computed: {
    evenement() {
      //console.log(this.$store.getters['evenements/'].getEvenementById(this.evenementID))
      return this.$store.getters['evenements/getEvenementById'](this.evenementID)
    },
    action() {
      return this.$store.getters['actions/getActionById'](this.actionID)
    }
  },
  methods: {
    showToast(toastType) {
      toast.showToast(toastType)
    },
    async reloadData(){
      await this.$store.dispatch('sollicitations/reloadSingleSollicitation', this.sollicitationID)
      toast.showToast('success', "Vous allez être redirigé");

      // // Si on passe d'un état "Ouvert" à un autre état, on refresh toutes les sollicitations
      // if (this.currentEtat=='A'){
      //     await this.$store.dispatch('sollicitations/clearSollicitations')
      //   }
      // toast.showToast('success', "Vous allez être redirigé");
    },
    async createSuivi(e) {
      e.preventDefault()

      let object = {};

      let myForm = document.getElementById('myForm');
      let formData = new FormData(myForm);
      formData.append("username", this.$store.getters['user/getPrenomNOM']);
      if (this.$store.getters['user/getCodePec'])
        formData.append("auteur", this.$store.getters['user/getCodePec']);

      formData.forEach((value, key) => {
        object[key] = value
      });


      let json = JSON.stringify(object);

      this.showOverlay = true
      let success = await this.$store.dispatch('suivis/createSuivi', json)

      if (success) {
        toast.showToast('success', 'Le suivi a bien été enregistrée')
        
      await this.reloadData()
        .then(() => {
          this.showOverlay = false          
          this.$router.push({name: 'fichesuivi', params:{id : this.sollicitationID}})
          })
        
        this.showOverlay = false
      } else {
        this.showOverlay = false
        toast.showToast('error', 'Echec de l\'envoi essayez à nouveau')
      }
    }
  }
}
</script>

<style scoped>

form {
  padding-bottom: 20px;
}

.categorisation {
  display: none;
}

.shadow-textarea textarea.form-control::placeholder {
  font-weight: 300;
}

.shadow-textarea textarea.form-control {
  padding-left: 0.8rem;
}


</style>